module.exports = __webpack_public_path__ + "static/media/header-layout.7cc49173.png";